import React, { Component } from "react";
import Header from "../../components/header/Header";
import { handleLandingScroll } from "../../utils/scroll";
import { trackPageview } from "../../utils/analytics";

class Contact extends Component {
  componentDidMount() {
    handleLandingScroll(this.props.location);
    trackPageview();
  }
  render() {
    return (
      <>
        <div className="grid-bg" />
        <Header theme={this.props.theme} />

        <div className="wrap">

          {/* HERO */}
          <section className="hero">
            <div className="label-strip">
              <span><b>GET IN TOUCH</b></span>
              <span>REPLY &lt; 24H</span>
              <span><b>OPEN</b> Q3 ’26</span>
            </div>

            <h1 className="huge">
              <span className="row">DROP</span>
              <span className="row">A <span className="ital">line</span><span className="accent-bg">.</span></span>
            </h1>

            <div className="sub-row">
              <p>
                I'm a <b>web scraping and automation expert</b> with full-stack
                development capabilities. Available on LinkedIn and Gmail —
                feel free to reach out and I'll respond within 24 hours.
              </p>
              <div className="meta-block">
                <div className="k">LOGISTICS</div>
                <div className="row"><span className="lab">BASE</span><span>CASABLANCA, MA</span></div>
                <div className="row"><span className="lab">TIMEZONE</span><span>GMT+1 · NO DST</span></div>
                <div className="row"><span className="lab">HOURS</span><span>09:00 – 19:00</span></div>
                <div className="row"><span className="lab">REPLY</span><span>&lt; 24H</span></div>
                <div className="row"><span className="lab">BOOKING</span><span>~6 WEEKS OUT</span></div>
              </div>
            </div>
          </section>

          {/* CHANNELS */}
          <section className="section" id="channels">
            <div className="section-head">
              <h2 className="section-title">01 <em>·</em> CHANNELS</h2>
              <div className="meta"><b>04</b><br/>OPEN</div>
            </div>

            <div className="channel-list">
              <div className="channel">
                <span className="ch-label">EMAIL</span>
                <span className="ch-val">
                  <a href="mailto:maaninou.walid@gmail.com">maaninou.walid@gmail.com</a>
                </span>
                <span className="ch-go">→</span>
              </div>
              <div className="channel">
                <span className="ch-label">GITHUB</span>
                <span className="ch-val">
                  <a href="https://github.com/walidMaaninou" target="_blank" rel="noopener noreferrer">github.com/walidMaaninou</a>
                </span>
                <span className="ch-go">↗</span>
              </div>
              <div className="channel">
                <span className="ch-label">LINKEDIN</span>
                <span className="ch-val">
                  <a href="https://www.linkedin.com/in/walid-maaninou-86a844102/" target="_blank" rel="noopener noreferrer">in/walid-maaninou</a>
                </span>
                <span className="ch-go">↗</span>
              </div>
              <div className="channel">
                <span className="ch-label">CV</span>
                <span className="ch-val">
                  <a href="#/cv">walidmaaninou.com/#/cv</a>
                </span>
                <span className="ch-go">→</span>
              </div>
            </div>
          </section>

          {/* WHAT HELPS */}
          <section className="section">
            <div className="section-head">
              <h2 className="section-title">02 <em>·</em> WHAT HELPS</h2>
              <div className="meta">FIRST<br/><b>EMAIL</b></div>
            </div>

            <p style={{ fontSize: 17, lineHeight: 1.6, maxWidth: "62ch", marginBottom: 18 }}>
              You don't have to send any of this, but if you do, I can give a useful answer faster:
            </p>

            <div className="role-list">
              <div className="role-block">
                <div className="when"><b>01</b></div>
                <div>
                  <h3>THE <em>problem</em></h3>
                  <p>One sentence on the problem you're trying to solve — not the technical solution you've already in mind.</p>
                </div>
                <div className="side"></div>
              </div>
              <div className="role-block">
                <div className="when"><b>02</b></div>
                <div>
                  <h3>THE <em>scale</em></h3>
                  <p>Rough numbers: rows, sites, requests, budget. Any one of those is enough to start.</p>
                </div>
                <div className="side"></div>
              </div>
              <div className="role-block">
                <div className="when"><b>03</b></div>
                <div>
                  <h3>THE <em>timeline</em></h3>
                  <p>Even approximate. "ASAP" is fine if it's the truth — it usually isn't.</p>
                </div>
                <div className="side"></div>
              </div>
              <div className="role-block">
                <div className="when"><b>04</b></div>
                <div>
                  <h3>PRIOR <em>attempts</em></h3>
                  <p>Whether you've already tried something that didn't work — and why you think it didn't.</p>
                </div>
                <div className="side"></div>
              </div>
            </div>
          </section>

          {/* QUOTE */}
        </div>

        {/* QUOTE SLAB */}
        <div className="wrap">
          <div className="quote-slab">
            <div className="inner">
              <q>Sorry for the long email — I didn't have time to write a <em>short</em> one.</q>
              <cite>— BLAISE PASCAL · SEND THE LONG ONE ANYWAY</cite>
            </div>
          </div>
        </div>

        {/* FINAL CTA SLAB */}
        <div className="wrap">
          <div className="foot-slab">
            <div className="inner">
              <h2>READY <em>when</em><br/>YOU ARE.</h2>
              <div>
                <p>Email is the fastest channel. I'll get back to you within the day.</p>
                <div className="links">
                  <a href="mailto:maaninou.walid@gmail.com">→ EMAIL <span>MAANINOU.WALID@GMAIL.COM</span></a>
                  <a href="https://www.linkedin.com/in/walid-maaninou-86a844102/">→ LINKEDIN <span>IN/WALID-MAANINOU</span></a>
                  <a href="https://github.com/walidMaaninou">→ GITHUB <span>@WALIDMAANINOU</span></a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer className="site-footer">
          <span>© 2026 MAANINOU WALID · CASABLANCA · GMT+1</span>
          <span>
            <a href="mailto:maaninou.walid@gmail.com">EMAIL</a>
            <a href="https://github.com/walidMaaninou">GITHUB</a>
            <a href="https://www.linkedin.com/in/walid-maaninou-86a844102/">LINKEDIN</a>
          </span>
        </footer>
      </>
    );
  }
}

export default Contact;
